module.exports = __webpack_public_path__ + "static/media/sofiivka.4b29978e.jpg";